// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReqSelectionCardCmp$PorterinFeature from "../../../../ui/components/ReqSelectionCardCmp.mjs";
import * as SpotRequirementModuleScss from "../styles/SpotRequirement.module.scss";

var styles = SpotRequirementModuleScss;

function SpotRequirementCmp(Props) {
  var requirement = Props.requirement;
  var show_modal = Props.show_modal;
  var form = Props.form;
  var requirement_content = Props.requirement_content;
  var match = React.useState(function () {
        return requirement;
      });
  var setRequirement = match[1];
  var requirement$1 = match[0];
  var requirements = [
    requirement_content.personal,
    requirement_content.business
  ];
  return React.createElement("div", {
              className: styles["requirement-wrapper"]
            }, React.createElement("div", {
                  className: styles["label-required"]
                }, requirement_content.requirement_title), React.createElement("div", {
                  className: styles.requirement
                }, requirements.map(function (card_data, index) {
                      return React.createElement(ReqSelectionCardCmp$PorterinFeature.make, {
                                  card_data: card_data,
                                  requirement: requirement$1,
                                  click_handler: (function (param) {
                                      Curry._1(setRequirement, (function (param) {
                                              return card_data.requirement;
                                            }));
                                      Curry._1(show_modal, (function (param) {
                                              return false;
                                            }));
                                      Curry._2(form.updateRequirement, (function (input, value) {
                                              return {
                                                      pickup_address: input.pickup_address,
                                                      drop_address: input.drop_address,
                                                      name: input.name,
                                                      mobile: input.mobile,
                                                      requirement: value,
                                                      consent_for_callback: input.consent_for_callback
                                                    };
                                            }), card_data.requirement);
                                    }),
                                  key: String(index)
                                });
                    })));
}

var make = SpotRequirementCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
